import { useNavigate } from "react-router-dom";
import classes from "./SideBar.module.css";
import { useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { useAuth } from "../../context/AuthContext";
import CarIcon from "../../icons/CarIcon";
import MultiUsersIcon from "../../icons/MultiUsersIcon";
import UserListIcon from "../../icons/UserListIcon";
import HelpIcon from "../../icons/HelpIcon";
import ChartIcon from "../../icons/ChartIcon";
import CalendarIcon from "../../icons/CaIendarIcon";


const navList = [
  {
    icon: <CalendarIcon />,
    activeIcon: <CalendarIcon active={true} />,
    name: "Bookings",
    link: "bookings",
  },
  {
    icon: <CarIcon />,
    activeIcon: <CarIcon active={true}/>,
    name: "Cars",
    link: "cars",
  },
  {
    icon: <MultiUsersIcon />,
    activeIcon: <MultiUsersIcon active={true} />,
    name: "Users",
    link: "users",
  },
  {
    icon: <UserListIcon />,
    activeIcon: <UserListIcon active={true} />,
    name: "Members",
    link: "members"
  },
  {
    icon: <HelpIcon />,
    activeIcon: <HelpIcon active={true} />,
    name: "Support",
    link: "support"
  },
  {
    icon: <ChartIcon />,
    activeIcon: <ChartIcon active={true} />,
    name: "Insights",
    link: "insights"
  }
];

const NavContainer = ({ icon, title, active, onClick, onMouseEnter, onMouseLeave }) => {
  return (
    <div
      className={`d-flex align-items-center gap-2 ${classes.navContainer} ${active ? classes.tabActive : ""}`}
      onClick={onClick}
      role="button"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {icon}
      <h4>{title}</h4>
    </div>
  );
};

const SideBar = ({ mobileOpen, onClose }) => {
  const [showCardNav, setShowCardNav] = useState(false);
  const [hovered, setHovered] = useState(null);
  const navigate = useNavigate();

  const { user, logout } = useAuth();

  const handleNavigate = (link) => {
    navigate(link);
    setShowCardNav(false);
    if (onClose) onClose();
  };

  return (
    <>
      {mobileOpen && (
        <div className={classes.mobileOverlay} onClick={onClose} />
      )}
      <div
        className={`d-flex flex-column justify-content-between ${classes.wrapper} ${mobileOpen ? classes.mobileOpen : ""}`}
      >
        <div>
          <div className={`mb-5 ${classes.logoRow}`}>
            <img src={`/tiji-logo.svg`} />
            {mobileOpen && (
              <IoCloseOutline
                size={28}
                className={classes.closeIcon}
                onClick={onClose}
                role="button"
              />
            )}
          </div>
          <div>
            {navList.map((item, i) => (
              <div className={classes.navWrapper} key={i}>
                <NavContainer
                  title={item.name}
                  icon={
                    (window.location.pathname.includes(item.link) || hovered === i)
                      ? item.activeIcon
                      : item.icon
                  }
                  active={window.location.pathname.includes(item.link) || hovered === i}
                  onMouseEnter={() => setHovered(i)}
                  onMouseLeave={() => setHovered(null)}
                  onClick={() => handleNavigate(item.link)}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default SideBar;
